import React, { useMemo } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { contextOfChildForm } from "../../../shared/formObjects/application/contextOfChildForm";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function ContextOfChildComponent({ disabled, data }: any) {
  const formApi = useApiClient("ContextOfChild");
  const { applicationBase, id } = useApplicationContext();

  const formContext = useMemo(
    () => ({
      applicationCategory: applicationBase.applicationType?.applicationCategory ?? 1,
      subcriteria: applicationBase.applicationType?.disabilitySubcriteria,
    }),
    []
  );
  return (
    <>
      {" "}
      <BaseApplicationComponent
        formBody={contextOfChildForm}
        headerLabel="Context of the Child"
        editPath="contextofchild"
        apiClient={formApi}
        disabled={disabled}
        data={data}
        id={id}
        formContext={formContext}
        print={true}
      />
    </>
  );
}
